import type {ProgressPhase} from './PaymentProgress';

type CardFaceState = 'idle' | 'ready' | 'verify' | 'proc' | 'ok' | 'fail';

const PHASE_CARD_STATE: Record<ProgressPhase, CardFaceState> = {
  processing: 'proc',
  success: 'ok',
  error: 'fail',
};

function getCardFaceState(
  phase: ProgressPhase | undefined,
  {isVerifying = false, isFormComplete = false} = {},
): CardFaceState {
  if (phase === 'processing' && isVerifying) return 'verify';
  if (phase) return PHASE_CARD_STATE[phase];
  return isFormComplete ? 'ready' : 'idle';
}

export {getCardFaceState};
export type {CardFaceState};
